import { fetcher, throwApiError } from '@commenda/utils';
import { IDocumentAssemblerGenerationPreviewResponse } from './generation-types';
import { GENERATIONS_URL } from './helpers';

export const renderDocumentAssemblerGenerationPreview = async (
  generationId: string
): Promise<IDocumentAssemblerGenerationPreviewResponse> => {
  const res = await fetcher(`${GENERATIONS_URL}/${generationId}/preview`, {
    method: 'POST',
    body: {},
  });

  if (!res.ok) {
    await throwApiError(
      res,
      'The document could not be generated. Try again in a moment.'
    );
  }

  return (await res.json()) as IDocumentAssemblerGenerationPreviewResponse;
};
